import { useQueryPayee } from "../../../../query/payee/queries/useQueryPayee";
import React from "react";
import { getPayeeName } from "../../../Payees/selectors/getPayeeNames";
import { WSElement, WSText } from "@wingspanhq/fe-component-library";

export const PayeeName: React.FC<{ payeeId: string }> = ({ payeeId }) => {
  const queryPayee = useQueryPayee(payeeId);

  if (queryPayee.data) {
    return <>{getPayeeName(queryPayee.data)}</>;
  } else if (queryPayee.isError) {
    return <WSText.ParagraphXs color="red500">error</WSText.ParagraphXs>;
  } else {
    return <WSElement as="i" shimmer pb="L" style={{ display: "block" }} />;
  }
};
